module.exports = __webpack_public_path__ + "media/public/images/icon-avatar-55b09970d1bb734f979fb6f35f5dcc25.svg";